import { render, staticRenderFns } from "./detReqAppendixCF.vue?vue&type=template&id=37dfdf75&"
import script from "./detReqAppendixCF.vue?vue&type=script&lang=js&"
export * from "./detReqAppendixCF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports